import { db } from '../utils/firebase';

// get all images for homepage sliders
export const getImages = async () => {
  const snapshot = await db.collection("home").get();
  const collections = [];
  snapshot.forEach(doc => {
    const { title, link, order, image, linkText } = doc.data();
    collections.push({ title, link, image, order, linkText });
  });

  // sort each section
  collections.sort((a, b) => a.order - b.order);

  return Promise.resolve(collections);
}